import { render, staticRenderFns } from "./ApplyKidSurveyForm.vue?vue&type=template&id=164edced&scoped=true"
import script from "./ApplyKidSurveyForm.vue?vue&type=script&lang=js"
export * from "./ApplyKidSurveyForm.vue?vue&type=script&lang=js"
import style0 from "./ApplyKidSurveyForm.vue?vue&type=style&index=0&id=164edced&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164edced",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('164edced')) {
      api.createRecord('164edced', component.options)
    } else {
      api.reload('164edced', component.options)
    }
    module.hot.accept("./ApplyKidSurveyForm.vue?vue&type=template&id=164edced&scoped=true", function () {
      api.rerender('164edced', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/survey_form/dialog/ApplyKidSurveyForm.vue"
export default component.exports